import { parseInlineMarkers } from '../inline-markup/parse-inline-markers';

export type InlineTextRun = { kind: 'text'; text: string };
export type InlineLinkRun = { kind: 'link'; index: number; text: string };
export type InlineRun = InlineTextRun | InlineLinkRun;

/**
 * @deprecated Use `parseInlineMarkers` from `shared/inline-markup`.
 *
 * The link-only view of the grammar, kept because it is public API. Markers now
 * also carry marks (`{b|word}`) and line breaks (`{br|}`), which this shape
 * cannot express, so anything that is not a linked span is flattened into text:
 * marked spans contribute their words without the marks, and a break
 * contributes a newline. That is exactly what a caller stripping markers out of
 * a string wants — `resolveAccordionSummary` is the one in this package — and
 * it is wrong for anything that means to render them.
 *
 * Adjacent text is merged, so text with no linked spans is still one run.
 */
export function parseInlineLinkMarkers(value: string): InlineRun[] {
  const runs: InlineRun[] = [];
  let pendingText = '';

  const flushPendingText = () => {
    if (pendingText !== '') {
      runs.push({ kind: 'text', text: pendingText });
      pendingText = '';
    }
  };

  for (const run of parseInlineMarkers(value)) {
    if (run.kind === 'span' && run.index !== undefined) {
      flushPendingText();
      runs.push({ kind: 'link', index: run.index, text: run.text });
      continue;
    }
    pendingText += run.kind === 'break' ? '\n' : run.text;
  }

  flushPendingText();

  return runs;
}
